// @ts-nocheck
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const sideMenuWrapperStyles = (padding = ".75em 0") => {
    return css`
        font-size: ${({ theme }) => theme.design.typography.size.base};
        line-height: ${({ theme }) => theme.design.typography.lineHeight.small};
        padding: ${padding};
    `;
};

export const sideMenuLinkStyles = (padding = "0.75em 1.5em", linksTakeAllWidth = false) => {
    const sideBordersColor = linksTakeAllWidth ? "common.accent" : "common.background";
    return css`
        width: 100%;
        padding: ${padding};
        font-weight: ${({ theme }) => theme.design.typography.weight.base};
        border-left: ${pxToRem(5)} solid ${getColor(sideBordersColor)};
        border-right: ${pxToRem(5)} solid ${getColor(sideBordersColor)};
        outline-offset: -${getProp("theme.focus.width")};
        background-color: ${getColor("common.background")};
        color: ${getColor("primary")};

        &:hover {
            text-decoration: underline;
        }
    `;
};

export const sideMenuLinkActiveStyles = () => {
    return css`
        font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        color: ${getColor("primary")};
        border-left-color: ${getColor("common.borderColored")};

        &:hover {
            text-decoration: none;
        }
    `;
};
